__webpack_require__.p = "https://rapidshop.pl/";